import { api } from './api';

export interface Brand {
  name: string;
  sub: string;
  tagline: string;
  logo_url: string;
  brand_color: string;
  favicon: string;
}

// Nome do produto por DEPLOY (VITE_PRODUCT_NAME no build). Sem ele, o nome
// interno; com ele (GNC DESK), o cliente nunca vê o nome interno.
const NOME_DO_PRODUTO = (import.meta.env.VITE_PRODUCT_NAME as string | undefined)?.trim();

export const DEFAULT_BRAND: Brand = {
  name: NOME_DO_PRODUTO || 'WIREDESK',
  sub: NOME_DO_PRODUTO ? '' : 'OS',
  tagline: 'Sala de controle editorial',
  logo_url: '',
  brand_color: '',
  favicon: '',
};

export const brandService = {
  // Público — funciona sem token (login/boot leem antes de autenticar). O
  // backend resolve o cliente pelo token quando há um, senão pelo Host.
  get: (): Promise<Brand> => api.get<Brand>('/brand'),
  // Staff. `client` (slug) escolhe de quem é a marca; omitido = marca da CASA,
  // que é a neutra mostrada antes do login num host compartilhado.
  update: (patch: Partial<Brand>, client?: string): Promise<Brand> =>
    api.put<Brand>(
      client ? `/brand?client=${encodeURIComponent(client)}` : '/brand',
      patch,
    ),
  // Lê a marca de um cliente específico para edição (staff).
  getFor: (client: string): Promise<Brand> =>
    api.get<Brand>(`/brand/scope?client=${encodeURIComponent(client)}`),
};
